import React from 'react';

import { ChangeLogListing } from './ChangeLogListing';

interface Props {
  csId: string;
}

export const ChangeLogCard = ({ csId }: Props) => {
  return <ChangeLogListing csId={csId} />;
};
